import React from 'react';

const PlusIcon = ({ size = 14, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 14.8333 14.8333" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.41667 0.75V14.0833" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M0.75 7.41667H14.0833" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default PlusIcon;
